import Feature from 'Services/Feature';

const taxesUrl = '/taxes';
const settingsTaxesUrl = '/settings/taxes';
export default {
    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes
     */
    async getAllTaxes() {
        const params = {
            order: 'rank',
            include_ecotax: true,
            limit: 100,
            embed: ['acl', 'translations'],
        };

        if (Feature.isEnabled('einvoicing-vat-parameters')) {
            params.embed.push('non_compliant_usage');
        }

        const taxesResult = [];
        let result = await ApiClient.get(taxesUrl, params);
        taxesResult.push(...result.data.data);
        while (taxesResult.length < result.data.pagination.total) {
            params.offset = taxesResult.length;
            result = await ApiClient.get(taxesUrl, params);
            taxesResult.push(...result.data.data);
        }
        return taxesResult;
    },

    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes settings for VatSettings.vue
     */
    getTaxesSettings() {
        return ApiClient.get(settingsTaxesUrl);
    },

    /**
     *
     * @param {Array} taxes
     * @returns {Promise}
     * Update all taxes and fetch again to keep them sync with server
     */
    updateTaxes(taxes) {
        return new Promise((resolve, reject) =>
            ApiClient.post(`${taxesUrl}/batch`, {}, taxes)
                .then((response) => {
                    if (response.status !== 204) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                }),
        );
    },

    updateEcoTaxes(ecoTaxes) {
        const taxesCopy = JSON.parse(JSON.stringify(ecoTaxes)).map((tax) => {
            return {
                id: tax.id,
                label: tax.label,
                translations: [...tax.translations.filter((item) => item.value.trim())],
            };
        });

        return new Promise((resolve, reject) =>
            ApiClient.post('/ecotaxes/batch', {}, taxesCopy)
                .then((response) => {
                    if (response.status !== 204) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                }),
        );
    },

    /**
     *
     * @param {Array} settingsTaxes
     * Update all settings for taxes
     */
    updateTaxesSettings(settingsTaxes, signal = undefined) {
        settingsTaxes.discount.value = settingsTaxes.discount.value?.toString() ?? '0';
        return new Promise((resolve, reject) => {
            ApiClient.put(settingsTaxesUrl, {}, { ...settingsTaxes }, signal)
                .then((response) => {
                    if (response.status !== 200) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    getTaxesMetadata() {
        return ApiClient.get('/taxes/metadata');
    },
};
